import React, { Fragment, useRef, useState, useEffect, useCallback } from 'react'

import LazyLoad from 'react-lazy-load'
import { useSelector, shallowEqual } from 'react-redux'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'

import { SimpleCarousel } from '.'
import { useEventListener, useWindowSize } from '../../_helpers'
import {
    Container,
    Meta,
    Title,
    devices,
    colors,
} from '../Common'

const ImageCard = ({ image, openModal }) => {
    const [spans, setSpans] = useState(0)
    const imageRef = useRef()

    const setSpan = () => {
        const height = imageRef.current.clientHeight
        const spans = Math.ceil(height / 10)
        setSpans(spans)
    }

    useEffect(setSpan, [])

    useEventListener('resize', setSpan)
    useEventListener('load', setSpan)

    return (
        <div style={{ gridRowEnd: `span ${spans}` }}>
            <img ref={imageRef} src={image.image} alt={image.alt_text} onClick={openModal} />
        </div>
    )
}


const PageView = () => {
    const { page, notFound } = useSelector(state => state.content, shallowEqual)
    const { gallery, title } = page
    const [showLightBox, setShowLightBox] = useState(false)
    const [activeSlide, setactiveSlide] = useState(0)
    const { width } = useWindowSize()
    const mobile = width < 480

    if (notFound) return <Redirect to='/' />

    const openModal = (i) => {
        setactiveSlide(i)
        setShowLightBox(true)
    }

    const closeModal = () => setShowLightBox(false)

    useEffect(closeModal, [page])

    return (
        <Fragment>
            <Meta page={page} />
            <PageContainer>
                {gallery ?
                    showLightBox ?
                        <SimpleCarousel title={title} slides={gallery} close={closeModal} activeImage={activeSlide} />
                        :
                        <>
                            <Title fontSize={mobile ? 14 : 16}>{title}</Title>
                            <ImageList>
                                {gallery.map((image, i) => <ImageCard key={i} image={image} openModal={() => openModal(i)} />)}
                            </ImageList>
                        </>
                    : ''}
            </PageContainer>
        </Fragment>
    )
}

const PageContainer = styled(Container)`
    min-height: 100vh;
    background: ${colors.black};
    padding: 50px;

    @media ${devices.small} {
        min-height: calc(100vh - 90px);
        padding: 20px;
    }
`

const ImageList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, 33%);
    justify-content: space-evenly;
    grid-row-gap: 10px;
    grid-auto-rows: 1px;

    img {
        width: 93%;
        border: 10px solid white;
        cursor: pointer;
    }

    @media ${devices.small} {
        grid-template-columns: repeat(auto-fill, 50%);

        img {
            border-width: 3px;
        }
    }
`

export default PageView
